// z-index 계층 관리
export const zIndex = {
  // 기본 레벨
  base: 1,
  dropdown: 10,

  // 네비게이션 (낮은 우선순위)
  sideMenu: 1200,
  header: 100,

  // 오버레이
  overlay: 200,

  // 모달 시스템 (높은 우선순위)
  modalBackdrop: 1300,
  modal: 1301,
  modalContent: 1302,

  // 로더 (모달 위)
  dataLoader: 1400,

  // 최고 우선순위
  tooltip: 2000,
  notification: 3000,
};

export default zIndex;